import { useEffect, useMemo, useState } from "react";
import './Importer.css'
import Pressable from "../../other/Pressable";
import moment from "moment";
import BotoPestanyaUp from "../controller/botons/BotoPestanyaUp";
import BotoPestanyaDown from "../controller/botons/BotoPestanyaDown";
import { fetchAPI } from "../../../utils/utils";
import {
    buildAvailableImportPreviewPosicions,
    buildImportedPestanyaLog,
    getPlantillaFromPestanya,
    getPosicionsLogFromData,
    normalizePestanya
} from "./importLog";
import { mergeImportedPosicionsLog, mergeImportedPosicionsWithSources } from "./importMerge";
import { MODELS_EVENT_ID } from '../../interface/proves/modelFolders';

function Importer(props) {
    const { assistenciesEvent, setCastellBeingImported, json, pestanya, setPestanya, importing, setImporting, posicionsLog, setPosicionsLog, selectedEvent, selectedBundle, selectedVersio, socket, ajuntamentLabel, ajuntamentEmoji, modelPaths } = props;

    const [events, setEvents] = useState([]);
    const [eventsInfo, setEventsInfo] = useState([]);
    const [castells, setCastells] = useState([]);
    const [posicionsLogs, setPosicionsLogs] = useState(null);
    const [posicions, setPosicions] = useState(null);

    const [originalPosicionsLog, setOriginalPosicionsLog] = useState([]);

    const [previewedEvent, setPreviewedEvent] = useState(null);
    const [previewedCastell, setPreviewedCastell] = useState(null);
    const [previewedVersio, setPreviewedVersio] = useState(null);

    const [bundlesInfo, setBundlesInfo] = useState([]);
    const [eventLabels, setEventLabels] = useState({});
    const [posicionsLogPerPestanya, setPosicionsLogPerPestanya] = useState({});

    const [selectedCastell, setSelectedCastell] = useState(null);
    const normalizedPestanya = normalizePestanya(pestanya);

    const selectedBundleInfo = useMemo(
        () => bundlesInfo?.find(bundle => bundle.id === selectedBundle),
        [bundlesInfo, selectedBundle]
    );

    const bundleIsSimultani = selectedBundleInfo?.simultani

    const castellsWithPestanya = useMemo(() => (
        Object.keys(selectedBundleInfo?.bundles || {})
            .filter(id => getPlantillaFromPestanya(id, selectedBundle, pestanya, bundlesInfo))
    ), [bundlesInfo, pestanya, selectedBundle, selectedBundleInfo]);

    const nCastells = castellsWithPestanya.length
    const numCastell = castellsWithPestanya.indexOf(selectedCastell)

    useEffect(() => {
        if (nCastells > 0) {
            setSelectedCastell(castellsWithPestanya[0])
        }
    }, [castellsWithPestanya, nCastells])

    const localeOptions = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        timeZone: 'UTC'
      };

    useEffect(() => {
        const handleAvailableImports = imports => {
            setEvents(imports.events);
            setCastells(imports.castells);
            setPosicionsLogs(imports.posicionsLog);
        };

        const requestImports = () => socket.emit('.request_available_imports', selectedEvent, selectedBundle, selectedVersio);
        const onFoldersChanged = event => {
            if (String(event) === String(MODELS_EVENT_ID)) requestImports();
        };
        socket.on('.available_imports', handleAvailableImports);
        socket.on('.model_folders_updated', onFoldersChanged);
        socket.on('connect', requestImports);
        requestImports();

        return () => {
            socket.off('.available_imports', handleAvailableImports);
            socket.off('.model_folders_updated', onFoldersChanged);
            socket.off('connect', requestImports);
        };
    }, [selectedEvent, selectedBundle, selectedVersio, socket]);
    
    useEffect(() => {
        fetchAPI('/bundles', setBundlesInfo)
    }, [])

    const chosenPartId = selectedCastell
    const plantillaFromPestanya = getPlantillaFromPestanya(chosenPartId, selectedBundle, pestanya, bundlesInfo)

    useEffect(() => {
        if (posicionsLogs === null) return;

        setPosicions(buildAvailableImportPreviewPosicions({
            posicionsLogs,
            json,
            pestanya,
            chosenPartId
        }))
    }, [json, chosenPartId, posicionsLogs, pestanya]);

    useEffect(() => {
        if (selectedEvent === null || selectedBundle === null || selectedVersio === null) return;
        socket.emit('.load_positions', selectedEvent, selectedBundle, selectedVersio);
        // loadPositions(selectedEvent, selectedBundle, selectedVersio)
    }, [selectedEvent, selectedBundle, selectedVersio, socket])

    useEffect(() => {
        const handleLoadedPositions = res => {
            if (res.event === selectedEvent && res.castell === selectedBundle && res.versio === selectedVersio) {
                if ('error' in res) {
                    console.log(res.error)
                } else {
                    setOriginalPosicionsLog(getPosicionsLogFromData(res.data))
                }
            } else if (res.event === previewedEvent && res.castell === previewedCastell && res.versio === previewedVersio) {
                if ('error' in res) {
                    console.log(res.error)
                } else {
                    const fullPosicionsLog = getPosicionsLogFromData(res.data)
                    const chosenBundleIsSimultani = bundlesInfo
                        ?.find(bundle => bundle.id === previewedCastell)
                        ?.simultani
                    const selectionKey = !chosenBundleIsSimultani ? selectedCastell : 'tots';
                    const posicionsLogPestanya = buildImportedPestanyaLog({
                        fullPosicionsLog,
                        json,
                        pestanya,
                        chosenPartId,
                        chosenBundleIsSimultani
                    });

                    setPosicionsLogPerPestanya(prev => ({
                        ...prev,
                        [selectionKey]: {
                            ...prev?.[selectionKey],
                            [normalizedPestanya]: {
                                event: previewedEvent,
                                castell: previewedCastell,
                                versio: previewedVersio, 
                                posicions: posicionsLogPestanya,
                                part: Object.entries(bundlesInfo.find(bundle => bundle.id === previewedCastell)?.parts || {})
                                    .find(([_, plant]) => normalizePestanya(plant) === normalizePestanya(plantillaFromPestanya))
                                    ?.[0]
                            }
                        }
                    }))
                }
            }
        };

        socket.on('.loaded_positionsv2', handleLoadedPositions);

        return () => {
            socket.off('.loaded_positionsv2', handleLoadedPositions)
        }
    }, [
        bundlesInfo,
        chosenPartId,
        json,
        normalizedPestanya,
        pestanya,
        plantillaFromPestanya,
        previewedCastell,
        previewedEvent,
        previewedVersio,
        selectedBundle,
        selectedCastell,
        selectedEvent,
        selectedVersio,
        socket
    ])

    useEffect(() => {
        const mergedPosicionsLog = mergeImportedPosicionsLog({
            json,
            originalPosicionsLog,
            posicionsLogPerPestanya
        });

        if (mergedPosicionsLog.length > 0) {
            setPosicionsLog(mergedPosicionsLog)
        }
    }, [posicionsLogPerPestanya, originalPosicionsLog, json, setPosicionsLog])

    const importCastell = () => {
        if (posicionsLog.length > 0) {
            const merged = mergeImportedPosicionsWithSources({ json, originalPosicionsLog, posicionsLogPerPestanya, selectedEvent });
            // Es conserven l'etiqueta i l'emoji del punt de referència de la prova destí
            const etiquetaOption = ajuntamentLabel ? `,etiqueta=${encodeURIComponent(ajuntamentLabel)}` : ''
            const emojiOption = ajuntamentEmoji ? `,emoji=${encodeURIComponent(ajuntamentEmoji)}` : ''
            const posicionsLogToWrite = [
                `OPTIONS:ajuntament=${0}${etiquetaOption}${emojiOption}`,
                merged.logs.join('\n')
            ]
                .join('\n')

            socket.emit('.import_from_log', posicionsLogToWrite, [selectedEvent, selectedBundle, selectedVersio], [null, ...merged.sourceEvents], response => {
                if (!response?.success) {
                    window.alert(response?.error || 'No s’ha pogut importar la pinya.');
                    return;
                }
                socket.emit('.load_positions', selectedEvent, selectedBundle, selectedVersio);
                setImporting(false);
            });
            return;
        }

        socket.emit('.load_positions', selectedEvent, selectedBundle, selectedVersio);
        setImporting(false);
    };

    const previewImport = (event, castell_versio) => {
        if (castell_versio.split('.').length !== 3) return;
        const [castell, versio] = castell_versio.split('.');

        setPreviewedEvent(event.id)
        setPreviewedCastell(castell)
        setPreviewedVersio(versio)
    };

    useEffect(() => {        
        if (previewedCastell !== null && previewedEvent !== null && previewedVersio !== null) {
            // loadPositions(previewedEvent, previewedCastell, previewedVersio)
            socket.emit('.load_positions', previewedEvent, previewedCastell, previewedVersio);
        }
    }, [previewedCastell, previewedEvent, previewedVersio, socket])

    useEffect(() => {
        const savedInfo = posicionsLogPerPestanya?.[selectedCastell]?.[normalizedPestanya]
        const savedInfoTots = posicionsLogPerPestanya?.tots?.[normalizedPestanya]

        if (savedInfo) {
            setPreviewedEvent(savedInfo.event)
            setPreviewedCastell(savedInfo.castell)
            setPreviewedVersio(savedInfo.versio)
        } else if (savedInfoTots) {
            setPreviewedEvent(savedInfoTots.event)
            setPreviewedCastell(savedInfoTots.castell)
            setPreviewedVersio(savedInfoTots.versio)
        } else {
            setPreviewedEvent(null)
            setPreviewedCastell(null)
            setPreviewedVersio(null)
        }
    }, [normalizedPestanya, posicionsLogPerPestanya, selectedCastell])

    useEffect(() => {
        if (events.length === 0) return;

        const handleEventsInfo = info => setEventsInfo(prev => [...new Map([...prev, ...info].map(event => [String(event.id), event])).values()]);

        socket.emit('.request_events', events);
        socket.on('.events_info', handleEventsInfo);

        return () => socket.off('.events_info', handleEventsInfo);
    }, [events, socket]);

    useEffect(() => {
        if (events.length === 0) return;

        const eventsToFetch = events
            .filter(eventId => eventId)
            .filter(eventId => !(eventId in eventLabels));
        if (eventsToFetch.length === 0) return;

        eventsToFetch.forEach(eventId => {
            fetchAPI(`/prova_labels/${eventId}`, data => {
                setEventLabels(prev => ({
                    ...prev,
                    [eventId]: data || {}
                }));
            });
        });
    }, [events, eventLabels]);

    useEffect(() => {
        if (bundleIsSimultani && importing) {
            setCastellBeingImported(chosenPartId)
        } else {
            setCastellBeingImported(null)
        }
    }, [bundleIsSimultani, chosenPartId, importing, setCastellBeingImported])

    const capFirst = (string) => string.charAt(0).toUpperCase() + string.slice(1);

    const emptyPosicions = { caixes: [], castellers: [] };

    const llista_imports = events
        .map((id, i) => [eventsInfo.find(ev => String(ev.id) === String(id)) || {}, castells[i] || [], ((posicions && posicions[i]) || emptyPosicions)])
        .filter(([event, castellsInEvent]) => Object.keys(event).length !== 0)
        .filter(([event, castellsInEvent]) => castellsInEvent.length !== 0)
        .sort((a, b) => new Date(a[0]['data-esperada-inici']) < new Date(b[0]['data-esperada-inici']) ? 1 : -1)
        .map(([event, castellsInEvent, posicionsCastell], ev_k) => {
            // Folder paths enumerate active models, including unclassified ones.
            // Keep stale socket responses from proposing an archived model.
            const isAvailable = castell => String(event.id) !== String(MODELS_EVENT_ID) || !modelPaths || Object.prototype.hasOwnProperty.call(modelPaths, castell);
            const associatedBundles = castellsInEvent
                .map(castell => bundlesInfo.find(bundle => bundle.id === castell.split('.')[0]))

            const simultanisMap = associatedBundles
                .map(bundle => bundleIsSimultani && (bundle?.id === selectedBundle) ? bundle : {})
                .map(bundle =>
                    Object.values(bundle?.bundles || {})
                        .map(b => Object.values(b.parts))
                        .some(plantilles => plantilles.some(plantilla => normalizePestanya(plantilla) === normalizePestanya(plantillaFromPestanya)))
                )

            const matchedBundlesMap = associatedBundles
                .map(bundle => Object.values(bundle?.parts || {}))
                .map(parts => parts.some(part => normalizePestanya(part) === normalizePestanya(plantillaFromPestanya)))

            const matchedPart = associatedBundles
                .map(bundle => Object.entries(bundle?.parts || {}))
                .map(parts => parts.find(([_, plant]) => normalizePestanya(plant) === normalizePestanya(plantillaFromPestanya)))
                .map(part => capFirst(part?.[0] || ''))

            const hasMatchingBundle = castellsInEvent.some((castell, k) => isAvailable(castell) && (matchedBundlesMap[k] || simultanisMap[k]));
            if (!hasMatchingBundle) return null;

            const MOMENT_MAX = moment('2099-12-29')
            const isModel = moment(event['data-esperada-inici']).isAfter(MOMENT_MAX);

            const selectedVersions = Object.values(posicionsLogPerPestanya || {})
                .map(pestanyes => Object.entries(pestanyes))
                .flat()
                .map(([part, data]) => `${part}.${data?.versio}`)

            return (
                <div style={{
                    marginBottom: isModel ? 50 : 10,
                }} key={event.id}>
                    {
                        isModel ?
                            <div>
                                <strong>
                                    PINYA MODEL
                                </strong>
                            </div>
                        :
                            <div>
                                {
                                    moment(event?.['data-esperada-inici']).isAfter(moment()) && <em>(FUTUR)&nbsp;</em>
                                }
                                <strong>{event.title}</strong> - {event['tipus'] && capFirst(event['tipus'])} de {new Date(event['data-esperada-inici']).toLocaleString('ca-ES', localeOptions)}
                            </div>
                    }
                    <div>
                        {castellsInEvent.map((castell, k) => {
                            if (!isAvailable(castell) || (!matchedBundlesMap[k] && !simultanisMap[k])) return null;

                                const castellersInProva =
                                    (k < posicionsCastell.length
                                        ? (Object.keys(posicionsCastell[k].castellers) || [])
                                        : [])
                                        .map((casteller, i) =>
                                            (assistenciesEvent || []).find(c => parseInt(c.id) === parseInt(casteller)) ||
                                            undefined
                                        )

                            const n_fitxats = castellersInProva.filter(c => c && c["assistència"] === 2).length;
                            const n_assistents = castellersInProva.filter(c => c && c["assistència"] === 1).length;
                            const n_inassistents = castellersInProva.filter(c => c && c["assistència"] === 0).length;
                            const n_no_resposta = castellersInProva.filter(c => c && c["assistència"] === null).length;

                            const n_castellers = castellersInProva.length;
                            const empty = n_fitxats === 0 && n_assistents === 0 && n_inassistents === 0 && n_no_resposta === 0;

                            const castellsVersio = castell.split('.')[1]
                            const castellIsCurrentlySelected = castellsVersio === previewedVersio
                            const castellIsAlreadyImported = selectedVersions.includes(`${normalizedPestanya}.${castellsVersio}`)
                            const eventId = event?.id || events?.[ev_k];
                            const bundleName = associatedBundles?.[k]?.nom || '';
                            const provaLabel = eventLabels?.[eventId]?.[castell];
                            const provaDisplayName = provaLabel && bundleName
                                ? `${bundleName} [${provaLabel}]`
                                : (provaLabel || bundleName);
                            const modelPath = modelPaths?.[castell];
                            const folderLabel = modelPaths === false ? 'Carpeta no disponible'
                                : !modelPaths ? 'Carregant carpeta…'
                                : modelPath && modelPath !== 'Sense carpeta' ? modelPath : null;

                            return (
                                <div
                                    onClick={() => {
                                        if (empty) return;
                                        if (castellsVersio !== previewedVersio) {
                                            previewImport(event, castell)
                                        } else {
                                            if (simultanisMap[k]) {
                                                setPosicionsLogPerPestanya(prev => ({
                                                    ...prev,
                                                    tots: {
                                                        ...prev?.tots,
                                                        [normalizedPestanya]: undefined
                                                    }
                                                }))
                                            } else {
                                                setPosicionsLogPerPestanya(prev => ({
                                                    ...prev,
                                                    [selectedCastell]: {
                                                        ...prev?.[selectedCastell],
                                                        [normalizedPestanya]: undefined
                                                    }
                                                }))
                                            }
                                        }
                                    }}
                                    className="prova"
                                    key={event.id+castell}
                                    style={{
                                        opacity:
                                            !castellIsCurrentlySelected && castellIsAlreadyImported ? 0.5 :
                                            1,
                                        backgroundColor:
                                            castellIsCurrentlySelected ? 'rgba(0,0,0,0.25)' :
                                            castellIsAlreadyImported ? 'rgba(0,0,0,0.1)' :
                                            simultanisMap[k] ? 'rgba(255,255,0,0.1)' :
                                            'white'
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-around',
                                            flex: 1,
                                        }}
                                    >
                                        <div className="prova-link" style={{ display: 'flex', flex: 1, minWidth: 0, justifyContent: 'center' }}>
                                            <div style={{ color: empty ? '#ccc' : 'darkblue', minWidth: 0 }}>
                                                ({ matchedPart[k] || (simultanisMap[k] && pestanya) }) {provaDisplayName}
                                                {String(event.id) === '999999' && folderLabel && <small style={{ display: 'block', color: '#657587', fontSize: 12, lineHeight: 1.4, marginTop: 4, maxWidth: '100%', overflowWrap: 'anywhere', whiteSpace: 'normal' }}>
                                                    {folderLabel}
                                                </small>}
                                            </div>
                                        </div>

                                        { !empty && <div className="prova-info" style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center', fontSize: 14 }}>
                                            { n_castellers > 0 && <div className="casteller-count">👤 { n_castellers }</div> }
                                            { n_fitxats > 0 && <div className="casteller-count">📍 { n_fitxats }</div> }
                                            { n_assistents > 0 && <div className="casteller-count">&#9989; { n_assistents }</div> }
                                            { n_inassistents > 0 && <div className="casteller-count">&#10060; { n_inassistents }</div> }
                                            { n_no_resposta > 0 && <div className="casteller-count">😶 { n_no_resposta }</div> }
                                        </div> }
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        })
        .filter(e => e !== null);

    return (
        <>
            <div className="import-button" onClick={importCastell}>
                Acabar la importació
            </div>

            <div id="controller-container" className={`extended`}>
                <div
                    style={{
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        margin: 20,
                    }}
                >
                    <BotoPestanyaUp full={true} tabs={props.tabs} pestanya={pestanya} setPestanya={setPestanya} />
                    <BotoPestanyaDown full={true} tabs={props.tabs} pestanya={pestanya} setPestanya={setPestanya} />
                </div>

                {
                    nCastells > 1 &&
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-around',
                            margin: 20,
                        }}
                    >
                        <button
                            onClick={() => {
                                setSelectedCastell(prev => {
                                    const next = (numCastell - 1 + nCastells) % nCastells
                                    return castellsWithPestanya[next]
                                })
                            }}
                        >
                            Castell anterior
                        </button>

                        <button
                            onClick={() => {
                                setSelectedCastell(prev => {
                                    const next = (numCastell + 1) % nCastells
                                    return castellsWithPestanya[next]
                                })
                            }}
                        >
                            Següent castell
                        </button>
                    </div>
                }

                <div className="llista-importer">
                    <div style={{ height: '90%', overflow: 'scroll' }}>
                        <Pressable
                            onClick={() => {
                                setPosicionsLogPerPestanya(prev => ({
                                    ...prev,
                                    [selectedCastell]: {
                                        ...prev?.[selectedCastell],
                                        [normalizedPestanya]: undefined
                                    },
                                    tots: {
                                        ...prev?.tots,
                                        [normalizedPestanya]: undefined
                                    }
                                }))
                            }}
                            className="prova"
                            style={{
                                marginBottom: 20,
                                backgroundColor: 'white'
                            }}
                            onPressColor={"#ccc"}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-around',
                                    flex: 1,
                                }}
                            >
                                <div className="prova-link" style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                                    <div style={{ color: 'darkblue' }}>
                                        Deixa en blanc {normalizedPestanya}
                                    </div>
                                </div>
                            </div>
                        </Pressable>

                        {
                            llista_imports.length > 0 ? llista_imports :
                            eventsInfo.length === 0 ? <em>Buscant pinyes compatibles...</em> :
                            <div>No hi ha cap {normalizedPestanya} per importar.</div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default Importer;
